import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { articles, getArticlesByCategory } from '@/mocks/gossip';

export default function RankingSection() {
  const ranking = articles.slice(0, 6);
  const styleItems = getArticlesByCategory('style');

  return (
    <section className="mx-auto max-w-[1240px] px-4 py-16 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="图集速览"
        title="本周热读榜与编辑精选"
        description="左边是大家都在看的内容，右边是造型解析里最值得慢慢读的几篇。"
      />

      <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <h3 className="flex items-center gap-2 border-b border-background-200 pb-4 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-fire-fill text-xl text-primary-500" aria-hidden="true"></i>
              本周热读榜
            </h3>
            <ol className="mt-2 divide-y divide-background-200">
              {ranking.map((article, index) => (
                <li key={article.id} className="flex items-center gap-4 py-4">
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                      index < 3
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h4 className="line-clamp-1 font-heading text-base font-semibold text-foreground-950 transition-colors hover:text-primary-600">
                      <Link to={`/article/${article.slug}`}>{article.title}</Link>
                    </h4>
                    <p className="mt-1 flex flex-wrap items-center gap-x-3 text-xs text-foreground-500">
                      <span>{article.categoryName}</span>
                      <span>{article.date}</span>
                    </p>
                  </div>
                  <span className="hidden shrink-0 text-xs font-medium text-accent-700 sm:block">
                    {article.views}
                  </span>
                </li>
              ))}
            </ol>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="h-full rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <h3 className="flex items-center gap-2 border-b border-background-200 pb-4 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-shirt-line text-xl text-accent-600" aria-hidden="true"></i>
              造型解析 · 编辑精选
            </h3>
            <div className="mt-4 flex flex-col gap-5">
              {styleItems.slice(0, 2).map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group flex gap-4 rounded-lg bg-background-50 p-3 transition-colors hover:bg-background-50/70"
                >
                  <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md md:h-24 md:w-28">
                    <img
                      src={article.image}
                      alt={article.alt}
                      title={`${article.title} - 诱惑吃瓜`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h4 className="line-clamp-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                      {article.title}
                    </h4>
                    <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
              <Link
                to="/category/style"
                className="flex h-10 items-center justify-center gap-1 whitespace-nowrap rounded-md bg-secondary-500 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
              >
                查看全部造型解析
                <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}